import React from 'react';
import { NavBar } from '../../../Modules/Navigation/components/NavBar/NavBar';
import Card from '../../../ui/Card/Card';
import styles from './Songs.module.css';
import ExploreSongs from '../../../Modules/Song/features/ExploreSongs/ExploreSongs';

const Songs = () => (
    <>
        <NavBar />
        <Card className={styles.content}>
            <ExploreSongs />
        </Card>
    </>
);

export default Songs;
